export default __webpack_public_path__ + "static/media/thainight7.7b3a4bbb.jpg";